module.exports = __webpack_public_path__ + "img/energy-trading-md.9f375b52.png";